/**
 * Logo Size Configuration
 * Adjust these values to resize logos across the app
 * All values are in Tailwind height classes (e.g., 'h-24' = 6rem = 96px)
 */

export const logoConfig = {
  // Therappi Logo Sizes
  therappi: {
    mobile: 'h-24',    // Adjust mobile Therappi logo size
    desktop: 'h-64',   // Adjust desktop Therappi logo size
  },
  
  // WHOOP Logo Sizes
  whoop: {
    mobile: 'h-16',    // Adjust mobile WHOOP logo size
    desktop: 'h-36',   // Adjust desktop WHOOP logo size
  },
  
  // Multiplication Symbol (×)
  multiplier: {
    mobile: {
      size: 'text-base',  // Text size for mobile
      topPadding: 'pt-4', // Vertical alignment for mobile
    },
    desktop: {
      size: 'text-2xl',   // Text size for desktop
      topPadding: 'pt-12', // Vertical alignment for desktop
    },
  },
  
  // Logo Alignment Padding
  whoopAlignment: {
    mobile: 'pt-2',  // Top padding for WHOOP mobile alignment
    desktop: 'pt-6', // Top padding for WHOOP desktop alignment
  },
  
  // Header Logo (in AppHeader)
  header: {
    mobile: 'h-20',   // Therappi logo in mobile header (increased)
    desktop: 'h-28',  // Therappi logo in desktop header (increased)
  },
};

/**
 * Instructions for adjusting logo sizes:
 * 
 * 1. To make logos BIGGER, increase the number (e.g., h-24 → h-32)
 * 2. To make logos SMALLER, decrease the number (e.g., h-24 → h-20)
 * 3. Common Tailwind height values: h-16, h-20, h-24, h-32, h-40, h-48, h-64
 * 4. To align logos vertically, adjust the pt-X (padding-top) values
 * 5. To adjust × symbol size, change text-base, text-lg, text-xl, text-2xl, etc.
 */
